/*
 *
 * NewPasswordPage reducer
 *
 */
import produce from 'immer';
import { CREATE_PASSWORD, CREATE_PASSWORD_SUCCESS, CREATE_PASSWORD_EXPIRED, CREATE_PASSWORD_FAIL, APP_META, APP_META_SUCCESS, APP_META_FAIL, APP_USER_REQUEST, APP_USER_SUCCESS, APP_USER_FAIL, } from './constants';
export var initialState = {
    loading: false,
    error: null,
    expired: false,
    appMetaLoading: false,
    appMetaError: false,
    appMeta: null,
    appUserLoading: false,
    appUserError: false,
    appUser: null,
};
function newPasswordPageReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case CREATE_PASSWORD:
                state.loading = true;
                state.error = null;
                state.expired = false;
                break;
            case CREATE_PASSWORD_SUCCESS:
                state.loading = false;
                state.error = null;
                state.expired = false;
                break;
            case CREATE_PASSWORD_EXPIRED:
                state.loading = false;
                state.error = action.err;
                state.expired = true;
                break;
            case CREATE_PASSWORD_FAIL:
                state.loading = false;
                state.error = action.err;
                state.expired = false;
                break;
            case APP_META:
                state.appMetaLoading = true;
                state.appMetaError = false;
                break;
            case APP_META_SUCCESS:
                state.appMetaLoading = false;
                state.appMetaError = false;
                state.appMeta = action.appMeta || null;
                break;
            case APP_META_FAIL:
                state.appMetaLoading = false;
                state.appMetaError = true;
                break;
            case APP_USER_REQUEST:
                state.appUserLoading = true;
                state.appUserError = false;
                break;
            case APP_USER_SUCCESS:
                state.appUserLoading = false;
                state.appUserError = false;
                state.appUser = action.appUser || null;
                break;
            case APP_USER_FAIL:
                state.appUserLoading = false;
                state.appUserError = true;
                break;
            default:
                break;
        }
    });
}
export default newPasswordPageReducer;
